function addEvents() {
    let header = document.querySelector("header");
    let headerHeight = header.offsetHeight;
    document.addEventListener("scroll",
        function() {
            let currentScrollPositionFromTop = window.pageYOffset;

            if (currentScrollPositionFromTop >= headerHeight * 2) {
                header.classList.add("is-out-of-view");
            } else {
                header.classList.remove("is-out-of-view");
            }
        });
}

//document ready in plain javascript
if (document.readyState === "complete" || (document.readyState !== "loading" && !document.documentElement.doScroll)
) {
    addEvents();
} else {
    document.addEventListener("DOMContentLoaded", addEvents);
}